import axios from 'axios'
import {Toast} from "vant";
import {baseURL} from "@/utils/url";


export function getThemeParams(key){
    // 尝试从缓存获取
    const storage = sessionStorage.getItem("theme-params");
    const themeParams = storage!=="undefined" && storage!==""?JSON.parse(storage):null;
    if (themeParams) return themeParams[key]
    let result = ""
    axios.get(baseURL + '/nonlogin/basic/getInfo.htm')
    .then(resp => {
      if (!resp || !resp.data || resp.data.code != 200){
          Toast(`获取模板参数失败`)
      }
      if(resp.data.data){
          sessionStorage.setItem("theme-params", JSON.stringify(resp.data.data))
          result = resp.data.data[key];
      }
    })
    .catch(function (error) {
      console.log(error);
    });
    return result;
}
